import React from "react";
import { Link } from "gatsby";

import imgMain from "../../assets/image/inner-page/png/equipment-content-1.png";
import imgDot from "../../assets/image/inner-page/png/dot-bg.png";

const Content = ({ className, ...rest }) => {
  return (
    <>
      <div className={className} {...rest}>
        <div className="container">
          <div className="row align-items-center justify-content-center">
            {/* Image Section */}
            <div className="col-xl-6 col-lg-5 col-md-7 col-xs-10">
              <div
                className="l1-content-image-group-1 mb-10 mb-lg-0"
                data-aos="fade-right"
                data-aos-duration={500}
                data-aos-once="true"
              >
                <img className="w-100" src={imgMain} alt="" />
                <div className="abs-img-1">
                  <img className="w-100" src={imgDot} alt="" />
                </div>
              </div>
            </div>
            {/* Content Section */}
            <div className="col-xl-6 col-lg-7 col-md-8 col-sm-11">
              <div
                className="ml-lg-10 ml-xl-12 mt-lg-n20 pr-lg-10 pr-xl-10"
                data-aos="fade-left"
                data-aos-duration={800}
                data-aos-delay={300}
                data-aos-once="true"
              >
                <h3 className="font-size-11 mb-5 mb-lg-8 font-weight-medium pr-sm-20 pr-md-16 pr-lg-0">
                  Equipa a tus empleados/as
                </h3>
                <p className="font-size-6 mb-0">
                  Con equipamiento puedes tener toda la gestión de uniformidad y
                  material que necesitan tus empleados/as para realizar su
                  jornada laboral al día.
                </p>
                {/* newsletter */}
                <div
                  className="mt-8 mt-lg-16"
                  data-aos="fade-left"
                  data-aos-duration={800}
                  data-aos-delay={500}
                  data-aos-once="true"
                >
                  <Link to="/contact" className="btn btn-blue-3 rounded-5">
                    Contacta con nosotros
                  </Link>
                </div>
                {/* End newsletter */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Content;
